import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { OutputConfigSlice } from "../../redux";
import { FetchFinalOutputList } from "../FinalOutputList/Scripts";
import { useUser } from "../../../../../AuthContext";
import { FinalOutputButtonsBarView } from "./FinalOutputButtonsBar.view";
import { data } from "./Data";

export const FinalOutputButtonsBar: React.FC = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const configId = outputConfig.selectedOutputConfig.id;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  /**
   * Health check button action
   */
  const onRunHealthCheck = (): void => {
    /**
     * To fetch final output status list
     * @param dispath item
     * @param translate item
     * @param config id
     */
    FetchFinalOutputList(dispatch, translate, configId, env, user?.token);
  };

  /**
   * Action on filter by dropdown is selected
   */
  const onFilterBy = (value: string): void => {
    dispatch(OutputConfigSlice.actions.setFinalOutputFilterBy(value));
  };

  return (
    <FinalOutputButtonsBarView
      onRunHealthCheck={onRunHealthCheck}
      data={data}
      onFilterBy={onFilterBy}
    />
  );
};
